<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="25" viewBox="0 0 13 25">
  <g [attr.stroke]="color" stroke-width="1" fill="none">
    <polyline points="13 1 0 12.5 13 24"/>
  </g>
</svg>
